export interface IssueFormat {
  message: string;
  detail?: string;
}

export interface IssueFormatContext {
  machineName?: string;
  machineCode?: string;
  fieldLabel?: string;
  nodeLabel?: string;
  count?: number;
}

const CODE_PATTERN = "[A-Za-z0-9_-]+";

export function formatIssue(code: string, ctx: IssueFormatContext = {}): IssueFormat {
  switch (code) {
    case "header:name-required":
      return {
        message: "Nome da linha obrigatório",
        detail: "Preencha o campo Nome no cabeçalho.",
      };
    case "machines:empty":
      return {
        message: "Linha sem máquinas",
        detail:
          "Adicione ao menos uma máquina pelo canvas para que o fluxo de produção tenha conteúdo.",
      };
    case "machine:name-empty":
      return {
        message: `Máquina ${ctx.machineName ?? ctx.machineCode ?? "sem nome"} — nome obrigatório`,
        detail: "Abra a máquina no painel lateral e preencha o nome.",
      };
    case "machine:code-empty":
      return {
        message: `Máquina ${ctx.machineName ?? "sem código"} — código obrigatório`,
        detail: "Códigos de máquina identificam o equipamento internamente.",
      };
    case "machine:code-invalid":
      return {
        message: `Máquina ${ctx.machineName ?? ctx.machineCode ?? ""} — código inválido`,
        detail: `Use apenas letras, números, _ ou - (padrão ${CODE_PATTERN}).`,
      };
    case "machine:orphan":
      return {
        message: `Máquina ${ctx.machineName ?? ctx.machineCode ?? ""} sem representação no canvas`,
        detail: "Arraste a máquina para o canvas para incluí-la no fluxo de produção.",
      };
    case "canvas:node:no-link":
      return {
        message: `Nó ${ctx.nodeLabel ?? "MACHINE"} sem ligação`,
        detail: "Conecte-o a outro nó para participar do fluxo.",
      };
    case "canvas:start-disconnected":
      return {
        message: "Início desconectado do fluxo",
        detail: "Conecte o nó Início a pelo menos uma máquina.",
      };
    case "canvas:end-disconnected":
      return {
        message: "Fim desconectado do fluxo",
        detail: "Conecte ao menos uma máquina ao nó Fim.",
      };
    default:
      return { message: code };
  }
}
